import { render, staticRenderFns } from "./Microbiology.vue?vue&type=template&id=379acb9c&scoped=true"
import script from "./Microbiology.vue?vue&type=script&lang=js"
export * from "./Microbiology.vue?vue&type=script&lang=js"
import style0 from "./Microbiology.vue?vue&type=style&index=0&id=379acb9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379acb9c",
  null
  
)

export default component.exports